export default __webpack_public_path__ + "static/media/SG-DarkBlue-0007.3109a08e.png";